module.exports = __webpack_public_path__ + "img/mm.ef94aa10.svg";